import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Shape from '../../../components/utils/shape';
import { default as _PAELLA } from '../../../utils';
import { colors } from '../../../styles';
import { useCustomizer } from './context';

const TimeBar = () => {
  const { actions } = useCustomizer();
  const [selected, setSelected] = useState(90);
  useEffect(() => {
    actions.updateSlice('duration', selected);
  }, [selected]);

  return (
    <>
      <div className="row-center align-center">
        <motion.div
          onClick={() => setSelected(60)}
          whileTap={{ scale: 1.1 }}
          whileHover={{ scale: 1.1 }}
          className="txt-pointer shape-container"
        >
          <Shape.HalfRight
            fill={selected === 60 ? colors.accent : colors.ultrapurple}
          />
        </motion.div>
        <motion.div
          className="txt-pointer shape-container"
          whileTap={{ scale: 1.1 }}
          whileHover={{ scale: 1.1 }}
          onClick={() => setSelected(90)}
        >
          <Shape.Circle
            fill={selected === 90 ? colors.accent : colors.ultrapurple}
            size={80}
          />
        </motion.div>
      </div>
      <p className="txt-uppercase -accent txt-s txt-left">{selected}'</p>
    </>
  );
};

export default TimeBar;
